// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__1p08J","short":"styles_short__3o_R4","medium":"styles_medium__2a-DS","long":"styles_long__2Q8c5","min":"styles_min__36eeG","max":"styles_max__10arB"};